"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SOLUTION_COLORS = exports.colorsValues = exports.widgetHighlightColorPalette = exports.matchingBaseColorMap = exports.matchingDWColorWithWashedColorMap = exports.matchingDarkerColorMap = exports.darkColors = exports.matchingDeepWashedColorMap = exports.matchingWashedColorMap = exports.calendarColors = exports.spotLightColors = exports.darkerBaseColors = exports.colorsSelectFontsMap = exports.colorsFontsMap = exports.defaultSolutionColor = exports.solutionColors = exports.defaultEventColor = exports.LandingPageColors = exports.SolutionColors = exports.PlanColors = exports.deepWashedColors = exports.washedColors = exports.baseColors = exports.darkerColors = exports.Colors = exports.GrayColors = exports.SolutionColorVariables = exports.IconColorNames = exports.TextColorNames = void 0;
exports.TextColorNames = {
    white: "#fff",
    primary: "#2E3538",
    secondary: "#878B92",
    tertiary: "#6B6B6B",
};
exports.IconColorNames = {
    light: "#C7CDCF",
    dark: "#2E3538",
    darker: "#151515",
};
exports.SolutionColorVariables = {
    sc1: "var(--solution-primary-color)",
    sc2: "var(--solution-secondary-color)",
    sc3: "var(--solution-hover-color)",
    sc4: "var(--solution-highlight-color)",
};
exports.GrayColors = {
    "G-0": "#FFFFFF",
    "G-0-5": "#FAFAFA",
    "G-1": "#F3F3F4",
    "G-1-2": "#F0F0F0",
    "G-1-5": "#E9E9E9",
    "G-2": "#DEDEDE",
    "G-3": "#C7C8C9",
    "G-4": "#B2B2B3",
    "G-5": "#9B9C9E",
    "G-6": "#868788",
    "G-7": "#6F7173",
    "G-8": "#4d4d4d",
    "G-9": "#232B36",
};
exports.Colors = {
    // === Darker === //
    dBlue: "#0C41F3",
    dLightBlue: "#00B3FA",
    dGreen: "#199A27",
    dRed: "#F1273F",
    dOrange: "#FF702E",
    dYellow: "#FDA80D",
    dPurple: "#673DB6",
    dPink: "#CD286A",
    dTeal: "#00B2A8",
    dGrey: "#2D2D2D",
    // === Base === //
    bBlue: "#3A86FF",
    bLightBlue: "#4ECCFD",
    bGreen: "#3EAC40",
    bRed: "#FF5757",
    bOrange: "#FF9210",
    bYellow: "#FFB938",
    bPurple: "#883CD0",
    bPink: "#EC506E",
    bTeal: "#17C4C4",
    bGrey: "#6A849B",
    // === Washed === //
    wBlue: "#B7E3FB",
    wLightBlue: "#B3EFFE",
    wGreen: "#CDEECE",
    wRed: "#FEBDC7",
    wOrange: "#FFD5B3",
    wYellow: "#FFECB3",
    wPurple: "#DFCCFF",
    wPink: "#FFC7E7",
    wTeal: "#C2F0ED",
    wGrey: "#D7D7DB",
    // === Deep Washed === //
    dwBlue: "#E7F0FE",
    dwLightBlue: "#E5F8FF",
    dwGreen: "#EEF6EE",
    dwRed: "#FEECEE",
    dwOrange: "#FFEDE5",
    dwYellow: "#FFF2DC",
    dwPurple: "#F2EAFA",
    dwPink: "#FBEAF1",
    dwTeal: "#EBF4F4",
    dwGrey: "#F1F2F3",
    custom1: "#FFFFFF",
    custom2: "#000000",
    custom3: "#F3F3F4",
    custom4: "#EFA00B",
    custom5: "#88bbd7",
    custom6: "#b2b2b3",
    custom7: "#fd7038",
    custom8: "#6F7173",
    custom9: "#20C933",
    custom10: "#DD1C1A",
    custom11: "#FDB402",
    custom12: "#A15DDC",
    custom13: "#FF09C3",
    custom14: "#20DAD2",
    custom15: "#2E3538",
    custom16: "#C7C8C9",
    custom17: "#FAFAFA",
    custom18: "#FFDB5C",
    linkedRecordFieldColor: "#E5F8FF",
    linkedRecordFieldHoverColor: "#E5F8FF",
    bulkActionMenuCloseColor: "#8391A6",
};
exports.darkerColors = [
    exports.Colors.dBlue,
    exports.Colors.dLightBlue,
    exports.Colors.dGreen,
    exports.Colors.dRed,
    exports.Colors.dOrange,
    exports.Colors.dYellow,
    exports.Colors.dPurple,
    exports.Colors.dPink,
    exports.Colors.dTeal,
    exports.Colors.dGrey,
];
exports.baseColors = [
    exports.Colors.bBlue,
    exports.Colors.bLightBlue,
    exports.Colors.bGreen,
    exports.Colors.bRed,
    exports.Colors.bOrange,
    exports.Colors.bYellow,
    exports.Colors.bPurple,
    exports.Colors.bPink,
    exports.Colors.bTeal,
    exports.Colors.bGrey,
];
exports.washedColors = [
    exports.Colors.wBlue,
    exports.Colors.wLightBlue,
    exports.Colors.wGreen,
    exports.Colors.wRed,
    exports.Colors.wOrange,
    exports.Colors.wYellow,
    exports.Colors.wPurple,
    exports.Colors.wPink,
    exports.Colors.wTeal,
    exports.Colors.wGrey,
];
exports.deepWashedColors = [
    exports.Colors.dwBlue,
    exports.Colors.dwLightBlue,
    exports.Colors.dwGreen,
    exports.Colors.dwRed,
    exports.Colors.dwOrange,
    exports.Colors.dwYellow,
    exports.Colors.dwPurple,
    exports.Colors.dwPink,
    exports.Colors.dwTeal,
    exports.Colors.dwGrey,
];
exports.PlanColors = {
    // === Primary Base === //
    basePrimaryDarkBlue: "#0055DB",
    basePrimaryBlue: "#3A86FF",
    basePrimaryOrange: "#FF9210",
    basePrimaryGreen: "#2b782D",
    // === Secondary Base === //
    baseSecondaryDarkBlue: "#008bc2",
    baseSecondaryBlue: "#6BB0FF",
    baseSecondaryOrange: "#FFBC80",
    baseSecondaryGreen: "#3EAC40",
};
exports.SolutionColors = {
    // === Primary Darker === //
    darkPrimaryBlue: "#0C41F3",
    darkPrimaryLightBlue: "#00B3FA",
    darkPrimaryGreen: "#199A27",
    darkPrimaryRed: "#F1273F",
    darkPrimaryOrange: "#FF702E",
    darkPrimaryYellow: "#FDA80D",
    darkPrimaryPurple: "#673DB6",
    darkPrimaryPink: "#CD286A",
    darkPrimaryTeal: "#00B2A8",
    darkPrimaryGrey: "#50515B",
    // === Secondary Darker === //
    darkSecondaryBlue: "#E7F0FE",
    darkSecondaryLightBlue: "#E7F7FE",
    darkSecondaryGreen: "#EEF6EF",
    darkSecondaryRed: "#FEECEE",
    darkSecondaryOrange: "#FFEDE5",
    darkSecondaryYellow: "#FFF2DB",
    darkSecondaryPurple: "#F2EAFA",
    darkSecondaryPink: "#FAEAF1",
    darkSecondaryTeal: "#EBF4F4",
    darkSecondaryGrey: "#F1F2F3",
    // === Hover Darker === //
    darkHoverBlue: "#0931B9",
    darkHoverLightBlue: "#008BC2",
    darkHoverGreen: "#10651A",
    darkHoverRed: "#BB0C20",
    darkHoverOrange: "#F04B00",
    darkHoverYellow: "#FA7900",
    darkHoverPurple: "#4E2E8A",
    darkHoverPink: "#9A1E4F",
    darkHoverTeal: "#00756F",
    darkHoverGrey: "#34353C",
    // === Highlight Darker === //
    darkHighlightBlue: "#0931B9",
    darkHighlightLightBlue: "#008BC2",
    darkHighlightGreen: "#10651A",
    darkHighlightRed: "#BB0C20",
    darkHighlightOrange: "#F04B00",
    darkHighlightYellow: "#FA7900",
    darkHighlightPurple: "#4E2E8A",
    darkHighlightPink: "#9A1E4F",
    darkHighlightTeal: "#00756F",
    darkHighlightGrey: "#34353C",
    // === Primary Base === //
    basePrimaryBlue: "#3A86FF",
    basePrimaryLightBlue: "#4ECCFD",
    basePrimaryGreen: "#3EAC40",
    basePrimaryRed: "#FF5757",
    basePrimaryOrange: "#FF9210",
    basePrimaryYellow: "#FFB938",
    basePrimaryPurple: "#883CD0",
    basePrimaryPink: "#EC506E",
    basePrimaryTeal: "#17C4C4",
    basePrimaryGrey: "#6A849B",
    // === Secondary Base === //
    baseSecondaryBlue: "#E7F0FE",
    baseSecondaryLightBlue: "#E5F8FF",
    baseSecondaryGreen: "#EEF6EE",
    baseSecondaryRed: "#FEECEE",
    baseSecondaryOrange: "#FFEDE5",
    baseSecondaryYellow: "#FFF2DC",
    baseSecondaryPurple: "#F2EAFA",
    baseSecondaryPink: "#FBEAF1",
    baseSecondaryTeal: "#EAF5F5",
    baseSecondaryGrey: "#F1F2F3",
    // === Hover Base === //
    baseHoverBlue: "#0055dB",
    baseHoverLightBlue: "#02AEF2",
    baseHoverGreen: "#2B782D",
    baseHoverRed: "#E50000",
    baseHoverOrange: "#FA7500",
    baseHoverYellow: "#FF9500",
    baseHoverPurple: "#6a29a8",
    baseHoverPink: "#DD183E",
    baseHoverTeal: "#129797",
    baseHoverGrey: "#4A5D6E",
    // === Highlight Base === //
    baseHighlightBlue: "#0055db",
    baseHighlightLightBlue: "#02aef2",
    baseHighlightGreen: "#2b782d",
    baseHighlightRed: "#e50000",
    baseHighlightOrange: "#FA7500",
    baseHighlightYellow: "#ff9500",
    baseHighlightPurple: "#6a29a8",
    baseHighlightPink: "#dd183e",
    baseHighlightTeal: "#129797",
    baseHighlightGrey: "#4a5d6e",
};
exports.LandingPageColors = {
    lpLightBlue: "#CEE8FD",
    lpLightGreen: "#BEE4BF",
    lpLightOrange: "#F6CCAC",
    lpLightOrangeTwo: "#FFD1A8",
    lpLightPink: "#FBC6C6",
    lpLightPurple: "#DDC4F7",
    lpLightYellow: "#FFE4A5",
    lpIconYellow: "#ffc94d",
    lpLightYellowTwo: "#FFE5A5",
};
exports.defaultEventColor = "#DEDEDE";
exports.solutionColors = [
    // Dark
    {
        primary: exports.SolutionColors.darkPrimaryBlue,
        hover: exports.SolutionColors.darkHoverBlue,
        highlight: exports.SolutionColors.darkHighlightBlue,
        secondary: exports.SolutionColors.darkSecondaryBlue,
    },
    {
        primary: exports.SolutionColors.darkPrimaryLightBlue,
        hover: exports.SolutionColors.darkHoverLightBlue,
        highlight: exports.SolutionColors.darkHighlightLightBlue,
        secondary: exports.SolutionColors.darkSecondaryLightBlue,
    },
    {
        primary: exports.SolutionColors.darkPrimaryGreen,
        hover: exports.SolutionColors.darkHoverGreen,
        highlight: exports.SolutionColors.darkHighlightGreen,
        secondary: exports.SolutionColors.darkSecondaryGreen,
    },
    {
        primary: exports.SolutionColors.darkPrimaryRed,
        hover: exports.SolutionColors.darkHoverRed,
        highlight: exports.SolutionColors.darkHighlightRed,
        secondary: exports.SolutionColors.darkSecondaryRed,
    },
    {
        primary: exports.SolutionColors.darkPrimaryOrange,
        hover: exports.SolutionColors.darkHoverOrange,
        highlight: exports.SolutionColors.darkHighlightOrange,
        secondary: exports.SolutionColors.darkSecondaryOrange,
    },
    {
        primary: exports.SolutionColors.darkPrimaryYellow,
        hover: exports.SolutionColors.darkHoverYellow,
        highlight: exports.SolutionColors.darkHighlightYellow,
        secondary: exports.SolutionColors.darkSecondaryYellow,
    },
    {
        primary: exports.SolutionColors.darkPrimaryPurple,
        hover: exports.SolutionColors.darkHoverPurple,
        highlight: exports.SolutionColors.darkHighlightPurple,
        secondary: exports.SolutionColors.darkSecondaryPurple,
    },
    {
        primary: exports.SolutionColors.darkPrimaryPink,
        hover: exports.SolutionColors.darkHoverPink,
        highlight: exports.SolutionColors.darkHighlightPink,
        secondary: exports.SolutionColors.darkSecondaryPink,
    },
    {
        primary: exports.SolutionColors.darkPrimaryTeal,
        hover: exports.SolutionColors.darkHoverTeal,
        highlight: exports.SolutionColors.darkHighlightTeal,
        secondary: exports.SolutionColors.darkSecondaryTeal,
    },
    {
        primary: exports.SolutionColors.darkPrimaryGrey,
        hover: exports.SolutionColors.darkHoverGrey,
        highlight: exports.SolutionColors.darkHighlightGrey,
        secondary: exports.SolutionColors.darkSecondaryGrey,
    },
    // Base
    {
        primary: exports.SolutionColors.basePrimaryBlue,
        hover: exports.SolutionColors.baseHoverBlue,
        highlight: exports.SolutionColors.baseHighlightBlue,
        secondary: exports.SolutionColors.baseSecondaryBlue,
    },
    {
        primary: exports.SolutionColors.basePrimaryLightBlue,
        hover: exports.SolutionColors.baseHoverLightBlue,
        highlight: exports.SolutionColors.baseHighlightLightBlue,
        secondary: exports.SolutionColors.baseSecondaryLightBlue,
    },
    {
        primary: exports.SolutionColors.basePrimaryGreen,
        hover: exports.SolutionColors.baseHoverGreen,
        highlight: exports.SolutionColors.baseHighlightGreen,
        secondary: exports.SolutionColors.baseSecondaryGreen,
    },
    {
        primary: exports.SolutionColors.basePrimaryRed,
        hover: exports.SolutionColors.baseHoverRed,
        highlight: exports.SolutionColors.baseHighlightRed,
        secondary: exports.SolutionColors.baseSecondaryRed,
    },
    {
        primary: exports.SolutionColors.basePrimaryOrange,
        hover: exports.SolutionColors.baseHoverOrange,
        highlight: exports.SolutionColors.baseHighlightOrange,
        secondary: exports.SolutionColors.baseSecondaryOrange,
    },
    {
        primary: exports.SolutionColors.basePrimaryYellow,
        hover: exports.SolutionColors.baseHoverYellow,
        highlight: exports.SolutionColors.baseHighlightYellow,
        secondary: exports.SolutionColors.baseSecondaryYellow,
    },
    {
        primary: exports.SolutionColors.basePrimaryPurple,
        hover: exports.SolutionColors.baseHoverPurple,
        highlight: exports.SolutionColors.baseHighlightPurple,
        secondary: exports.SolutionColors.baseSecondaryPurple,
    },
    {
        primary: exports.SolutionColors.basePrimaryPink,
        hover: exports.SolutionColors.baseHoverPink,
        highlight: exports.SolutionColors.baseHighlightPink,
        secondary: exports.SolutionColors.baseSecondaryPink,
    },
    {
        primary: exports.SolutionColors.basePrimaryTeal,
        hover: exports.SolutionColors.baseHoverTeal,
        highlight: exports.SolutionColors.baseHighlightTeal,
        secondary: exports.SolutionColors.baseSecondaryTeal,
    },
    {
        primary: exports.SolutionColors.basePrimaryGrey,
        hover: exports.SolutionColors.baseHoverGrey,
        highlight: exports.SolutionColors.baseHighlightGrey,
        secondary: exports.SolutionColors.baseSecondaryGrey,
    },
];
exports.defaultSolutionColor = {
    primary: exports.SolutionColors.basePrimaryBlue,
    hover: exports.SolutionColors.baseHoverBlue,
    highlight: exports.SolutionColors.baseHighlightBlue,
    secondary: exports.SolutionColors.baseSecondaryBlue,
};
exports.colorsFontsMap = [
    { background: exports.Colors.dBlue, font: exports.TextColorNames.white },
    { background: exports.Colors.dLightBlue, font: exports.TextColorNames.white },
    { background: exports.Colors.dGreen, font: exports.TextColorNames.white },
    { background: exports.Colors.dRed, font: exports.TextColorNames.white },
    { background: exports.Colors.dOrange, font: exports.TextColorNames.white },
    { background: exports.Colors.dYellow, font: exports.TextColorNames.white },
    { background: exports.Colors.dPurple, font: exports.TextColorNames.white },
    { background: exports.Colors.dPink, font: exports.TextColorNames.white },
    { background: exports.Colors.dGrey, font: exports.TextColorNames.white },
    { background: exports.Colors.dTeal, font: exports.TextColorNames.white },
    { background: exports.Colors.bBlue, font: exports.TextColorNames.white },
    { background: exports.Colors.bLightBlue, font: exports.TextColorNames.white },
    { background: exports.Colors.bGreen, font: exports.TextColorNames.white },
    { background: exports.Colors.bRed, font: exports.TextColorNames.white },
    { background: exports.Colors.bOrange, font: exports.TextColorNames.white },
    { background: exports.Colors.bYellow, font: exports.TextColorNames.white },
    { background: exports.Colors.bPurple, font: exports.TextColorNames.white },
    { background: exports.Colors.bPink, font: exports.TextColorNames.white },
    { background: exports.Colors.bTeal, font: exports.TextColorNames.white },
    { background: exports.Colors.bGrey, font: exports.TextColorNames.white },
    { background: exports.Colors.wBlue, font: exports.TextColorNames.primary },
    { background: exports.Colors.wLightBlue, font: exports.TextColorNames.primary },
    { background: exports.Colors.wGreen, font: exports.TextColorNames.primary },
    { background: exports.Colors.wRed, font: exports.TextColorNames.primary },
    { background: exports.Colors.wOrange, font: exports.TextColorNames.primary },
    { background: exports.Colors.wYellow, font: exports.TextColorNames.primary },
    { background: exports.Colors.wPurple, font: exports.TextColorNames.primary },
    { background: exports.Colors.wPink, font: exports.TextColorNames.primary },
    { background: exports.Colors.wTeal, font: exports.TextColorNames.primary },
    { background: exports.Colors.wGrey, font: exports.TextColorNames.primary },
    { background: exports.Colors.dwBlue, font: exports.TextColorNames.primary },
    { background: exports.Colors.dwLightBlue, font: exports.TextColorNames.primary },
    { background: exports.Colors.dwGreen, font: exports.TextColorNames.primary },
    { background: exports.Colors.dwRed, font: exports.TextColorNames.primary },
    { background: exports.Colors.dwOrange, font: exports.TextColorNames.primary },
    { background: exports.Colors.dwYellow, font: exports.TextColorNames.primary },
    { background: exports.Colors.dwPurple, font: exports.TextColorNames.primary },
    { background: exports.Colors.dwPink, font: exports.TextColorNames.primary },
    { background: exports.Colors.dwTeal, font: exports.TextColorNames.primary },
    { background: exports.Colors.dwGrey, font: exports.TextColorNames.primary },
];
exports.colorsSelectFontsMap = [
    { background: exports.Colors.dBlue, font: exports.TextColorNames.white },
    { background: exports.Colors.dLightBlue, font: exports.TextColorNames.white },
    { background: exports.Colors.dGreen, font: exports.TextColorNames.white },
    { background: exports.Colors.dRed, font: exports.TextColorNames.white },
    { background: exports.Colors.dOrange, font: exports.TextColorNames.white },
    { background: exports.Colors.dYellow, font: exports.TextColorNames.white },
    { background: exports.Colors.dPurple, font: exports.TextColorNames.white },
    { background: exports.Colors.dPink, font: exports.TextColorNames.white },
    { background: exports.Colors.dGrey, font: exports.TextColorNames.white },
    { background: exports.Colors.dTeal, font: exports.TextColorNames.white },
    { background: exports.Colors.bBlue, font: exports.TextColorNames.white },
    { background: exports.Colors.bLightBlue, font: exports.TextColorNames.white },
    { background: exports.Colors.bGreen, font: exports.TextColorNames.white },
    { background: exports.Colors.bRed, font: exports.TextColorNames.white },
    { background: exports.Colors.bOrange, font: exports.TextColorNames.white },
    { background: exports.Colors.bYellow, font: exports.TextColorNames.white },
    { background: exports.Colors.bPurple, font: exports.TextColorNames.white },
    { background: exports.Colors.bPink, font: exports.TextColorNames.white },
    { background: exports.Colors.bTeal, font: exports.TextColorNames.white },
    { background: exports.Colors.bGrey, font: exports.TextColorNames.white },
    { background: exports.Colors.wBlue, font: exports.TextColorNames.primary },
    { background: exports.Colors.wLightBlue, font: exports.TextColorNames.primary },
    { background: exports.Colors.wGreen, font: exports.TextColorNames.primary },
    { background: exports.Colors.wRed, font: exports.TextColorNames.primary },
    { background: exports.Colors.wOrange, font: exports.TextColorNames.primary },
    { background: exports.Colors.wYellow, font: exports.TextColorNames.primary },
    { background: exports.Colors.wPurple, font: exports.TextColorNames.primary },
    { background: exports.Colors.wPink, font: exports.TextColorNames.primary },
    { background: exports.Colors.wTeal, font: exports.TextColorNames.primary },
    { background: exports.Colors.wGrey, font: exports.TextColorNames.primary },
    { background: exports.Colors.dwBlue, font: exports.TextColorNames.primary },
    { background: exports.Colors.dwLightBlue, font: exports.TextColorNames.primary },
    { background: exports.Colors.dwGreen, font: exports.TextColorNames.primary },
    { background: exports.Colors.dwRed, font: exports.TextColorNames.primary },
    { background: exports.Colors.dwOrange, font: exports.TextColorNames.primary },
    { background: exports.Colors.dwYellow, font: exports.TextColorNames.primary },
    { background: exports.Colors.dwPurple, font: exports.TextColorNames.primary },
    { background: exports.Colors.dwPink, font: exports.TextColorNames.primary },
    { background: exports.Colors.dwTeal, font: exports.TextColorNames.primary },
    { background: exports.Colors.dwGrey, font: exports.TextColorNames.primary },
];
exports.darkerBaseColors = [...exports.darkerColors, ...exports.baseColors];
exports.spotLightColors = [
    ...exports.darkerBaseColors,
    ...exports.washedColors,
    ...exports.deepWashedColors,
];
exports.calendarColors = [
    ...exports.washedColors,
    ...exports.deepWashedColors,
    ...exports.darkerBaseColors,
];
/** Associate dark colors with a matching washed color. */
exports.matchingWashedColorMap = {
    // === Darker === //
    [exports.Colors.dBlue]: exports.Colors.wBlue,
    [exports.Colors.dLightBlue]: exports.Colors.wLightBlue,
    [exports.Colors.dGreen]: exports.Colors.wGreen,
    [exports.Colors.dRed]: exports.Colors.wRed,
    [exports.Colors.dOrange]: exports.Colors.wOrange,
    [exports.Colors.dYellow]: exports.Colors.wYellow,
    [exports.Colors.dPurple]: exports.Colors.wPurple,
    [exports.Colors.dPink]: exports.Colors.wPink,
    [exports.Colors.dTeal]: exports.Colors.wTeal,
    [exports.Colors.dGrey]: exports.Colors.wGrey,
    // === Base === //
    [exports.Colors.bBlue]: exports.Colors.wBlue,
    [exports.Colors.bLightBlue]: exports.Colors.wLightBlue,
    [exports.Colors.bGreen]: exports.Colors.wGreen,
    [exports.Colors.bRed]: exports.Colors.wRed,
    [exports.Colors.bOrange]: exports.Colors.wOrange,
    [exports.Colors.bYellow]: exports.Colors.wYellow,
    [exports.Colors.bPurple]: exports.Colors.wPurple,
    [exports.Colors.bPink]: exports.Colors.wPink,
    [exports.Colors.bTeal]: exports.Colors.wTeal,
    [exports.Colors.bGrey]: exports.Colors.wGrey,
};
/** Associate dark colors with a matching deep washed color. */
exports.matchingDeepWashedColorMap = {
    // === Darker === //
    [exports.Colors.dBlue]: exports.Colors.dwBlue,
    [exports.Colors.dLightBlue]: exports.Colors.dwLightBlue,
    [exports.Colors.dGreen]: exports.Colors.dwGreen,
    [exports.Colors.dRed]: exports.Colors.dwRed,
    [exports.Colors.dOrange]: exports.Colors.dwOrange,
    [exports.Colors.dYellow]: exports.Colors.dwYellow,
    [exports.Colors.dPurple]: exports.Colors.dwPurple,
    [exports.Colors.dPink]: exports.Colors.dwPink,
    [exports.Colors.dTeal]: exports.Colors.dwTeal,
    [exports.Colors.dGrey]: exports.Colors.dwGrey,
    // === Base === //
    [exports.Colors.bBlue]: exports.Colors.dwBlue,
    [exports.Colors.bLightBlue]: exports.Colors.dwLightBlue,
    [exports.Colors.bGreen]: exports.Colors.dwGreen,
    [exports.Colors.bRed]: exports.Colors.dwRed,
    [exports.Colors.bOrange]: exports.Colors.dwOrange,
    [exports.Colors.bYellow]: exports.Colors.dwYellow,
    [exports.Colors.bPurple]: exports.Colors.dwPurple,
    [exports.Colors.bPink]: exports.Colors.dwPink,
    [exports.Colors.bTeal]: exports.Colors.dwTeal,
    [exports.Colors.bGrey]: exports.Colors.dwGrey,
};
/** Dark colors that have a matching washed color */
exports.darkColors = Object.keys(exports.matchingWashedColorMap);
exports.matchingDarkerColorMap = {
    // === Base === //
    [exports.Colors.bBlue]: exports.Colors.dBlue,
    [exports.Colors.bLightBlue]: exports.Colors.dLightBlue,
    [exports.Colors.bGreen]: exports.Colors.dGreen,
    [exports.Colors.bRed]: exports.Colors.dRed,
    [exports.Colors.bOrange]: exports.Colors.dOrange,
    [exports.Colors.bYellow]: exports.Colors.dYellow,
    [exports.Colors.bPurple]: exports.Colors.dPurple,
    [exports.Colors.bPink]: exports.Colors.dPink,
    [exports.Colors.bTeal]: exports.Colors.dTeal,
    [exports.Colors.bGrey]: exports.Colors.dGrey,
    // === Washed === //
    [exports.Colors.wBlue]: exports.Colors.dBlue,
    [exports.Colors.wLightBlue]: exports.Colors.dLightBlue,
    [exports.Colors.wGreen]: exports.Colors.dGreen,
    [exports.Colors.wRed]: exports.Colors.dRed,
    [exports.Colors.wOrange]: exports.Colors.dOrange,
    [exports.Colors.wYellow]: exports.Colors.dYellow,
    [exports.Colors.wPurple]: exports.Colors.dPurple,
    [exports.Colors.wPink]: exports.Colors.dPink,
    [exports.Colors.wTeal]: exports.Colors.dTeal,
    [exports.Colors.wGrey]: exports.Colors.dGrey,
    // === Deep Washed === //
    [exports.Colors.dwBlue]: exports.Colors.dBlue,
    [exports.Colors.dwLightBlue]: exports.Colors.dLightBlue,
    [exports.Colors.dwGreen]: exports.Colors.dGreen,
    [exports.Colors.dwRed]: exports.Colors.dRed,
    [exports.Colors.dwOrange]: exports.Colors.dOrange,
    [exports.Colors.dwYellow]: exports.Colors.dYellow,
    [exports.Colors.dwPurple]: exports.Colors.dPurple,
    [exports.Colors.dwPink]: exports.Colors.dPink,
    [exports.Colors.dwTeal]: exports.Colors.dTeal,
    [exports.Colors.dwGrey]: exports.Colors.dGrey,
};
exports.matchingDWColorWithWashedColorMap = {
    // === Deep Washed === //
    [exports.Colors.dwBlue]: exports.Colors.wBlue,
    [exports.Colors.dwLightBlue]: exports.Colors.wLightBlue,
    [exports.Colors.dwGreen]: exports.Colors.wGreen,
    [exports.Colors.dwRed]: exports.Colors.wRed,
    [exports.Colors.dwOrange]: exports.Colors.wOrange,
    [exports.Colors.dwYellow]: exports.Colors.wYellow,
    [exports.Colors.dwPurple]: exports.Colors.wPurple,
    [exports.Colors.dwPink]: exports.Colors.wPink,
    [exports.Colors.dwTeal]: exports.Colors.wTeal,
    [exports.Colors.dwGrey]: exports.Colors.wGrey,
};
exports.matchingBaseColorMap = {
    // === Darker === //
    [exports.Colors.dBlue]: exports.Colors.bBlue,
    [exports.Colors.dLightBlue]: exports.Colors.bLightBlue,
    [exports.Colors.dGreen]: exports.Colors.bGreen,
    [exports.Colors.dRed]: exports.Colors.bRed,
    [exports.Colors.dOrange]: exports.Colors.bOrange,
    [exports.Colors.dYellow]: exports.Colors.bYellow,
    [exports.Colors.dPurple]: exports.Colors.bPurple,
    [exports.Colors.dPink]: exports.Colors.bPink,
    [exports.Colors.dTeal]: exports.Colors.bTeal,
    [exports.Colors.dGrey]: exports.Colors.bGrey,
    // === Washed === //
    [exports.Colors.wBlue]: exports.Colors.bBlue,
    [exports.Colors.wLightBlue]: exports.Colors.bLightBlue,
    [exports.Colors.wGreen]: exports.Colors.bGreen,
    [exports.Colors.wRed]: exports.Colors.bRed,
    [exports.Colors.wOrange]: exports.Colors.bOrange,
    [exports.Colors.wYellow]: exports.Colors.bYellow,
    [exports.Colors.wPurple]: exports.Colors.bPurple,
    [exports.Colors.wPink]: exports.Colors.bPink,
    [exports.Colors.wTeal]: exports.Colors.bTeal,
    [exports.Colors.wGrey]: exports.Colors.bGrey,
    // === Deep Washed === //
    [exports.Colors.dwBlue]: exports.Colors.bBlue,
    [exports.Colors.dwLightBlue]: exports.Colors.bLightBlue,
    [exports.Colors.dwGreen]: exports.Colors.bGreen,
    [exports.Colors.dwRed]: exports.Colors.bRed,
    [exports.Colors.dwOrange]: exports.Colors.bOrange,
    [exports.Colors.dwYellow]: exports.Colors.bYellow,
    [exports.Colors.dwPurple]: exports.Colors.bPurple,
    [exports.Colors.dwPink]: exports.Colors.bPink,
    [exports.Colors.dwTeal]: exports.Colors.bTeal,
    [exports.Colors.dwGrey]: exports.Colors.bGrey,
};
exports.widgetHighlightColorPalette = [
    exports.Colors.bBlue,
    exports.Colors.bGreen,
    exports.Colors.bOrange,
    exports.Colors.bRed,
    exports.Colors.bPurple,
    exports.Colors.bLightBlue,
    exports.Colors.bTeal,
    exports.Colors.bYellow,
    exports.Colors.bPink,
    exports.Colors.bGrey,
];
exports.colorsValues = [
    // === Darker === //
    exports.Colors.dBlue,
    exports.Colors.dLightBlue,
    exports.Colors.dGreen,
    exports.Colors.dRed,
    exports.Colors.dOrange,
    exports.Colors.dYellow,
    exports.Colors.dPurple,
    exports.Colors.dPink,
    exports.Colors.dTeal,
    exports.Colors.dGrey,
    // === Base === //
    exports.Colors.bBlue,
    exports.Colors.bLightBlue,
    exports.Colors.bGreen,
    exports.Colors.bRed,
    exports.Colors.bOrange,
    exports.Colors.bYellow,
    exports.Colors.bPurple,
    exports.Colors.bPink,
    exports.Colors.bTeal,
    exports.Colors.bGrey,
    // === Washed === //
    exports.Colors.wBlue,
    exports.Colors.wLightBlue,
    exports.Colors.wGreen,
    exports.Colors.wRed,
    exports.Colors.wOrange,
    exports.Colors.wYellow,
    exports.Colors.wPurple,
    exports.Colors.wPink,
    exports.Colors.wTeal,
    exports.Colors.wGrey,
    // === Deep Washed === //
    exports.Colors.dwBlue,
    exports.Colors.dwLightBlue,
    exports.Colors.dwGreen,
    exports.Colors.dwRed,
    exports.Colors.dwOrange,
    exports.Colors.dwYellow,
    exports.Colors.dwPurple,
    exports.Colors.dwPink,
    exports.Colors.dwTeal,
    exports.Colors.dwGrey,
    exports.Colors.custom1,
    exports.Colors.custom2,
    exports.Colors.custom3,
    exports.Colors.custom4,
    exports.Colors.custom5,
    exports.Colors.custom6,
    exports.Colors.custom7,
    exports.Colors.custom8,
    exports.Colors.custom9,
    exports.Colors.custom10,
    exports.Colors.custom11,
    exports.Colors.custom12,
    exports.Colors.custom13,
    exports.Colors.custom14,
    exports.Colors.custom15,
    exports.Colors.custom16,
    exports.Colors.custom17,
    exports.Colors.linkedRecordFieldColor,
    exports.Colors.linkedRecordFieldHoverColor,
    exports.Colors.bulkActionMenuCloseColor,
];
exports.SOLUTION_COLORS = "solution_colors";
